import { z } from "zod";
import { CollectNodeFieldTypeEnum } from "../../../../enum/nodes.enum";

export const collectNodeTextFieldSchema = z.object({
  type: z.literal(CollectNodeFieldTypeEnum.TEXT),
  placeholder: z.string().optional(),
});
